import { render } from "./NavItems.vue?vue&type=template&id=73090eeb&scoped=true&ts=true"
import script from "./NavItems.vue?vue&type=script&lang=ts"
export * from "./NavItems.vue?vue&type=script&lang=ts"

import "./NavItems.vue?vue&type=style&index=0&id=73090eeb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73090eeb"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSeparator});
